<script lang="ts" setup>
import { computed, provide, reactive } from 'vue'
import { DTFieldGroupProvider } from '../../keys'
import type { FieldInputSizes } from './types'

const props = defineProps<{
  size?: keyof typeof FieldInputSizes
}>()

provide(DTFieldGroupProvider, reactive({ size: props.size }))

const groupClass = computed<string[]>(() => {
  const cls = [
    'antialiased',
    'flex',
    'grow',
    'items-stretch',
    '[&>.dt-field-input]:grow',
    '[&>.dt-field-input]:basis-0',
    '[&>.dt-field-input:focus-within]:z-10',
    '[&>.dt-field-input:invalid]:z-10',
    '[&>.dt-field-select]:grow',
    '[&>.dt-field-select]:basis-0',
    '[&>.dt-field-select:focus]:z-10',
    '[&>.dt-field-select:invalid]:z-10',
    '[&>*:first-child]:rounded-l-lg',
    '[&>*:not(:first-child)]:rounded-l-none',
    '[&>*:last-child]:rounded-r-lg',
    '[&>*:not(:last-child)]:rounded-r-none',
    '[&>*:not(:first-child)]:-ml-[1px]',
    '[&>.dt-field-group:not(:last-child)]:pr-0',
    '[&>.dt-field-group:not(:first-child)]:pl-0',
  ]
  return cls
})
</script>

<template>
  <!-- eslint-disable tailwindcss/no-custom-classname -->
  <div
    class="dt-field-group"
    :class="groupClass"
  >
    <!-- eslint-enable tailwindcss/no-custom-classname -->
    <slot />
  </div>
</template>
